import { gql } from "graphql-tag";

export const QUERY_SIDEBAR_FILTERS = gql`
  query SidebarFilters($interestListIds: [ID!]!) {
    interestListsById(ids: $interestListIds) {
      id
      defaultSorting
      sidebarFilters {
        name
        label
        type
      }
      property {
        features {
          id
          name
        }
        id
        stages {
          id
          name
          enabled
          standard
        }
      }
    }
  }
`;
